import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { getSolutionContactDetailsByTag } from "./utils/data/getContactDetails";

export const useIsApp = () => {
  const router = useRouter();
  return router.query.app === "true";
};

export const setAnalyticsData = ({ pageInfo, productPages }) => {
  window.jlData = window.jlData || {};
  window.jlData.page = window.jlData.page || {};
  window.jlData.page.locale = {
    country: "uk",
    currency: "gbp",
    language: "en-gb",
  };
  if (pageInfo) {
    window.jlData.page.pageInfo = pageInfo;
  }
  if (productPages) {
    window.jlData.page.productPages = productPages;
  }
};

export const useScript = (url, attributes) => {
  useEffect(() => {
    if (!document.querySelector(`script[src="${url}"]`)) {
      const script = document.createElement("script");
      script.src = url;
      Object.keys(attributes).forEach(attrKey => {
        script.setAttribute(attrKey, attributes[attrKey]);
      });
      document.body.appendChild(script);
    }
  }, []);
};

export const useDecisionTreeLocation = () => {
  const router = useRouter();
  const base = router.pathname.replace("/customer-services/", "");
  const parts = router.query.dt ? router.query.dt.split("-") : [];
  return [base].concat(parts).join(" | ");
};

export const useLiveChat = tag => {
  const [chatConfig, setChatConfig] = useState(null);
  const [isLoading, setisLoading] = useState(!!tag);
  useEffect(() => {
    if (!tag) return;
    getSolutionContactDetailsByTag(tag)
      .then(c => {
        setChatConfig(c);
        setisLoading(false);
      })
      .catch(() => {
        setisLoading(false);
      });
  }, [tag]);
  return { chatConfig, isLoading };
};

export function useMediaQuery(query) {
  const [state, setState] = useState(typeof window !== "undefined" && window.matchMedia(query).matches);
  useEffect(() => {
    const matchMedia = window.matchMedia(query);
    function handleChange() {
      return setState(matchMedia.matches);
    }
    if (matchMedia.addListener) {
      matchMedia.addListener(handleChange);
    } else {
      matchMedia.addEventListener("change", handleChange);
    }

    return () => {
      if (matchMedia.removeListener) {
        matchMedia.removeListener(handleChange);
      } else {
        matchMedia.removeEventListener("change", handleChange);
      }
    };
  }, [query]);
  return state;
}
